import React, { useMemo } from "react";
import {
  sortReportBrands,
  SelectComponent,
  ReportFilterSection,
} from "../../../../shared";
import {
  REPORT_FILTER_LABELS,
  REPORT_FILTER_STYLES,
  REPORT_FILTER_CLASSES,
} from "../../../../constants";

import {
  emptyString,
  storesConstants,
} from "../../../admin-screens/constants";
import { groupsConstants, TEST_IDS } from "../../constants";

const DatePicker = (props) => {
  const {
    stores,
    spinner,
    allBrands,
    allGroups,
    dateState,
    setDateState,
    selectedBrand,
    selectedGroup,
    selectedLocation,
    setSelectedGroup,
    setSelectedBrand,
    setSelectedLocation,
    getGroupsAgainstBrandId,
    getStoresAgainstBrandId,
    getStoresAgainstGroupId,
  } = props;

  const handleBrandChange = (e) => {
    setSelectedBrand(e);
    if (e.id) {
      getStoresAgainstBrandId(e.id);
      getGroupsAgainstBrandId(e.id);
    }
    setSelectedGroup([]);
    setSelectedLocation([]);
  };

  const handleGroupChange = (e) => {
    setSelectedGroup(e);
    if (e.id) {
      getStoresAgainstGroupId(e.id);
    }
    setSelectedLocation([]);
  };

  // Derive brand options so cleared lists cannot leave old choices behind.
  const brands = useMemo(() => sortReportBrands(allBrands ?? []), [allBrands]);

  const isBrandsLoading = spinner(storesConstants.FETCH_ALL_BRANDS);
  const isGroupsLoading = spinner(groupsConstants.GROUPS_DATA);
  const isStoresLoading = spinner(storesConstants.FETCH_BRAND_LOCATIONS);

  return (
    <div className="container-fluid pt-3">
      <div className="notification-form shadow card px-2 mb-3">
        <div className="card-body py-4">
          <h5>Marketing Sales</h5>
          <hr />
          <ReportFilterSection
            dateState={dateState}
            setDateState={setDateState}
            testId={TEST_IDS.REPORT_FILTERS}
          >
            <SelectComponent
              value={selectedBrand}
              options={[
                {
                  value: emptyString,
                  name: REPORT_FILTER_LABELS.BRAND,
                  isDisabled: true,
                },
                ...brands,
              ]}
              onChange={handleBrandChange}
              placeholder={REPORT_FILTER_LABELS.BRAND}
              styles={REPORT_FILTER_STYLES}
              className={REPORT_FILTER_CLASSES.SPACED_SELECT}
              isLoading={isBrandsLoading}
              isDisabled={isBrandsLoading}
            />
            <SelectComponent
              value={selectedGroup}
              options={[
                {
                  value: emptyString,
                  name: REPORT_FILTER_LABELS.GROUP,
                },
                ...allGroups,
              ]}
              onChange={handleGroupChange}
              placeholder={REPORT_FILTER_LABELS.GROUP}
              styles={REPORT_FILTER_STYLES}
              className={REPORT_FILTER_CLASSES.SPACED_SELECT}
              isLoading={isGroupsLoading}
              isDisabled={isGroupsLoading || !selectedBrand?.id}
            />
            <SelectComponent
              value={selectedLocation}
              options={[
                {
                  value: emptyString,
                  name: REPORT_FILTER_LABELS.STORE,
                },
                ...stores,
              ]}
              onChange={(e) => setSelectedLocation(e)}
              placeholder={REPORT_FILTER_LABELS.STORE}
              styles={REPORT_FILTER_STYLES}
              className={REPORT_FILTER_CLASSES.SELECT}
              isLoading={isStoresLoading}
              isDisabled={isStoresLoading || !selectedBrand?.id}
            />
          </ReportFilterSection>
        </div>
      </div>
    </div>
  );
};

export default DatePicker;
